import axios, { AxiosError } from "axios";

export const api = axios.create({
  baseURL: import.meta.env.VITE_BACKEND_URL,
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json",
  },
});

export const django = axios.create({
  baseURL: import.meta.env.VITE_DJANGO_URL,
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json",
  },
});

export const isAxiosError = <ResponseType>(
  error: unknown
): error is AxiosError<ResponseType> => {
  return axios.isAxiosError(error);
};
